export default __webpack_public_path__ + "static/ramanSharma6-bd0075048e6fe1652195cc6b618e4e35.jpg";